import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "37.072",
  width: "50",
  viewBox: "0 0 50 37.072",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M50 2.46L47.485-.058 15.443 31.986 2.515 19.058 0 21.573l15.443 15.443"
  })]
});